import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import MainLayouts from "./layouts/MainLayouts";
import { Link } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { useQuery } from "helpers/utils";

function App() {
  const query = useQuery();
  const isDebug = query.debug;
  return (
    <MainLayouts summary={true}>
        <Container fluid>
        <Row>
          <Col lg={12} className="text-center p-4">
            <h2>Portal Order Golden Fast Network</h2>
            <p>Pilih layanan yang ingin Anda pesan:</p>
          </Col>
        </Row>
          <Row>
            <Col lg={3} className="p-3">
            <Link to="/orderdomain" className="btn btn-primary w-100">Domain</Link>
            </Col>
            <Col lg={3} className="p-3">
            <Link to="/orderhosting" className="btn btn-primary w-100">Hosting</Link>
            </Col>
            <Col lg={3} className="p-3">
            <Link to="/orderserver" className="btn btn-primary w-100">VPS</Link>
            </Col>
            <Col lg={3} className="p-3">
            <Link to="/orderdomainbackorder" className="btn btn-primary w-100">Domain Backorder</Link>
            </Col>
            <Col lg={3} className="p-3">
            <Link to="/orderproduct" className="btn btn-primary w-100">Other Product</Link>
            </Col>
            <Col lg={3} className="p-3">
            <Link to="/migrasihosting" className="btn btn-primary w-100">Migrasi Hosting</Link>
          </Col>
        </Row>
        {isDebug === "1" && (
          <Row>
            <Col lg={12} className="p-3 text-center">
              <small className="text-muted">Debug mode: ON</small>
            </Col>
          </Row>
        )}
        </Container>
    </MainLayouts>
  );
}

export default App;
